function brn_opn_qv(brn_cnt){
  var brn_qv = brn_cnt.replace("brn_opn_qv_","brn_opn_back_");
  document.getElementById(brn_qv).className = "btn_prd_qv_back";
}

function brn_qv_cls(brn_qv_cnt){
  var brn_btn = brn_qv_cnt.replace("brn_cls_btn_","brn_opn_back_");
  document.getElementById(brn_btn).className = "btn_prd_qv_back_hid";
}

function brn_add_prd(brn_add_cnt){
  var add_ttl = document.getElementById(brn_add_cnt).getAttribute("data-brnadd");
  var add_sku = document.getElementById(brn_add_cnt).getAttribute("data_brmsku");
  var add_img = document.getElementById(brn_add_cnt).getAttribute("data_imgur");
  var add_sku_List = [];
  if(document.getElementById("brn_send-product_list").getElementsByClassName("brn_estim-product")[0] != null){
    var add_prd_list = document.getElementById("brn_send-product_list").getElementsByClassName("brn_estim-product");
    for(var a = 0;a < add_prd_list.length; a++){
      add_sku_List.push(add_prd_list[a].getAttribute("data-addprdsku"));
    };
  };
  if(add_sku_List.indexOf(add_sku) == -1){
    var add_cnt = document.createElement("div");
    add_cnt.setAttribute("data-addprdsku",add_sku);
    add_cnt.className = "brn_estim-product";
    var add_cnt_img = document.createElement("img");
    add_cnt_img.setAttribute("src",add_img)
    add_cnt_img.className = "brn_estim-product_img"
    var add_cnt_ttl = document.createElement("div");
    add_cnt_ttl.textContent = add_ttl;
    add_cnt_ttl.className = "brn_estim-product_ttl"
    var add_cnt_btn = document.createElement("button");
    add_cnt_btn.textContent = "削除"
    add_cnt_btn.className = "brn_estim-product_btn"
    add_cnt_btn.setAttribute("onclick","brn_rmv_prd(this)")
    add_cnt.appendChild(add_cnt_img);
    add_cnt.appendChild(add_cnt_ttl);
    add_cnt.appendChild(add_cnt_btn);
    document.getElementById("brn_send-product_list").appendChild(add_cnt);
  };
}

function brn_rmv_prd(rmv_cnt){
  var prd_cnt = rmv_cnt.parentElement;
  prd_cnt.remove();
}

function brn_getzip(){
  var get_zip_data = true;
  var inpz_vl = document.getElementById("brn_inp_zip").value.replace(/-/g,"");
  var inpz_vl_spl = inpz_vl.substr(0,3) + "-" + inpz_vl.substr(3,4)
  var zt_div_list = document.getElementById("zip_cand_li").getElementsByClassName("brn_cand_cnt");
  for(var a = zt_div_list.length - 1;a >= 0 ;a--){
    var inpz_vl_get = zt_div_list[a].getAttribute("data-brn_adA");
    if(inpz_vl_spl == inpz_vl_get){
      var get_zip_data = false;
    };
    zt_div_list[a].remove();
  };
  if(get_zip_data == true){
    if(inpz_vl.length == 7){
      var zt_list = document.getElementById("zip_cand_li").getElementsByClassName("zip_cand_list_body")[0];
      var pndzipl = "https:" + document.getElementById("brn_send-form_sect").getElementsByClassName("brn_send-form_topttl")[0].getAttribute("data-pndzpl");
      jQuery.ajax({
        method: "GET",
        url: pndzipl,
        dataType: "text",
        success: function(zt_data) {
          var zt_dict = JSON.parse(zt_data);
          if(inpz_vl in zt_dict){
            var zt_dict_hit = zt_dict[inpz_vl];
            for(var b = 0;b < zt_dict_hit.length;b++){
              var zt_div = document.createElement("div");
              zt_div.textContent = "〒" + inpz_vl.substr(0,3) + "-" + inpz_vl.substr(3,4) + "：" + zt_dict_hit[b][0] + zt_dict_hit[b][1] + zt_dict_hit[b][2];
              zt_div.setAttribute("data-brn_adA",inpz_vl.substr(0,3) + "-" + inpz_vl.substr(3,4));
              zt_div.setAttribute("data-brn_adB",zt_dict[inpz_vl][0][0]);
              zt_div.setAttribute("data-brn_adC",zt_dict[inpz_vl][0][1]);
              zt_div.setAttribute("data-brn_adD",zt_dict[inpz_vl][0][2]);
              zt_div.setAttribute("onclick","brn_setzip(this)");
              zt_div.className = "brn_cand_cnt";
              zt_list.appendChild(zt_div);
            };
            if(zt_dict_hit.length == 1){
              document.getElementById("zip_cand_li").className = "zip_cand_list";
            }else{
              document.getElementById("zip_cand_li").className = "zip_cand_list_long";
            };
          };
        },
        error: function() {
          var zt_div = document.createElement("div");
          zt_div.textContent = "取得エラー";
          zt_div.className = "brn_cand_cnt";
          zt_list.appendChild(zt_div);
      }
      })
    };
  };
}

function brn_setzip(z_inp_dt){
  var brn_adA = z_inp_dt.getAttribute("data-brn_adA");
  var brn_adB = z_inp_dt.getAttribute("data-brn_adB");
  var brn_adC = z_inp_dt.getAttribute("data-brn_adC");
  var brn_adD = z_inp_dt.getAttribute("data-brn_adD");
  document.getElementById("brn_inp_zip").value = brn_adA;
  document.getElementById("brn_inp_tdfkn").value = brn_adB;
  document.getElementById("brn_inp_city").value = brn_adC;
  document.getElementById("brn_inp_address").value = brn_adD;
  document.getElementById("zip_cand_li").className = "zip_cand_list-hid";
}

function brn_zip_cand_cls(){
  document.getElementById("zip_cand_li").className = "zip_cand_list-hid";
}

document.addEventListener('click', function(e){
  if(!e.target.closest("#zip_cand_li")) {
    document.getElementById("zip_cand_li").className = "zip_cand_list-hid";
  };
});

function send_bef_check(){
  document.getElementById("brn_send_frm_prd_e").className = "brn_send_frm-e-hid";
  document.getElementById("brn_send_frm_mail_e").className = "brn_send_frm-e-hid";
  document.getElementById("brn_send_frm_mailat_e").className = "brn_send_frm-e-hid";
  document.getElementById("brn_send_frm_inp_e").className = "brn_send_frm-e-hid";
  var send_brn_dt = true;
  var prd_list = document.getElementById("brn_send-product_list").getElementsByClassName("brn_estim-product");
  var prd_list_text = "";
  var prd_list_sku = "";
  for(var a = 0;a < prd_list.length;a++){
    var prd_list_text = prd_list_text + "SKU：" + prd_list[a].getAttribute("data-addprdsku") + "／商品名：" + prd_list[a].getElementsByClassName("brn_estim-product_ttl")[0].textContent + ",\n";
    var prd_list_sku = prd_list_sku + prd_list[a].getAttribute("data-addprdsku") + ",";
  };
  document.getElementById("brn_inp_prd_txt").value = prd_list_text;
  document.getElementById("brn_inp_prd_sku").value = prd_list_sku;
  if(prd_list_text == ""){
    document.getElementById("brn_send_frm_prd_e").className = "brn_send_frm-e";
    var send_brn_dt = false;
  };
  var snd_m_A = document.getElementById("brn_inp_mail").value;
  var snd_m_B = document.getElementById("brn_inp_mail_sub").value;
  if(snd_m_A != snd_m_B){
    document.getElementById("brn_send_frm_mail_e").className = "brn_send_frm-e";
    var send_brn_dt = false;
  };
  if(snd_m_A.indexOf("@") < 0){
    document.getElementById("brn_send_frm_mailat_e").className = "brn_send_frm-e";
    var send_brn_dt = false;
  };
  var inp_req_list = ["brn_inp_first_name","brn_inp_last_name","brn_inp_first_kana","brn_inp_last_kana","brn_inp_zip","brn_inp_city","brn_inp_address","brn_inp_tel","brn_inp_mail","brn_inp_mail_sub"]
  for(var b = 0;b < inp_req_list.length;b++){
    if(document.getElementById(inp_req_list[b]).value == "" || document.getElementById(inp_req_list[b]).value == null){
      console.log(inp_req_list[b].value);
      document.getElementById("brn_send_frm_inp_e").className = "brn_send_frm-e";
      var send_brn_dt = false;
    };
  };
  if(document.getElementById("brn_inp_tdfkn").value == "nonp"){
    document.getElementById("brn_send_frm_inp_e").className = "brn_send_frm-e";
    var send_brn_dt = false;
  }
  if(send_brn_dt == true){
    document.getElementById("brn_snd_conf_back").className = "brn_snd_c_b";
  };
}
function brn_send_b_Y(){
  document.getElementById("brn_send_form_btn").click();
}
function brn_send_b_N(){
  document.getElementById("brn_snd_conf_back").className = "brn_snd_c_b-hid";
}